import ENV from "../env";
import getAuthHeaders from "./authHeaders";

const deleteCustomer = async (customerId) => {
  console.log(customerId)
  const headers = await getAuthHeaders();
  
  const response = await fetch(
    `${ENV.firebaseApiUrl}/customer/delete/${customerId}`,
    {
      method: "DELETE",
      headers,
    }
  );

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Delete customer failed: " + resData.message);
  }

  return resData.customerId;
};

export default deleteCustomer;
